import { Injectable } from '@angular/core';

@Injectable()
export class UploadIssuanceService {
  public listValid:any;
  public listInvalid:any;
  constructor() { }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/upload-issuance/upload-issuance.service.ts